import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { JobQuotationService } from '../../../../service/job-quotation.service';
import { ProviderService } from '../../../../service/provider.service';
import { AuthenticationService } from '../../../../service/system/authentication.service';
import { AuthState } from '../../../../store/authInfo/auth-state';
import { JobQuotationTraceComponent } from '../job-quotation-trace/job-quotation-trace.component';

@Component({
  selector: 'app-job-quotation-table',
  templateUrl: './job-quotation-table.component.html',
  styleUrls: ['./job-quotation-table.component.less']
})
export class JobQuotationTableComponent implements OnInit {

  @Input() jobId: any;
  @Input() jobStatus: any;
  jobQuotationList = [];
  jobQuotations = [];
  authState = null;
  thirdpartyJobProcess = false;
  constructor(
    private message: NzMessageService,
    private providerService: ProviderService,
    private jobQuotationService: JobQuotationService,
    private modalService: NzModalService,
    private store: Store,
    private authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.authState = this.store.selectSnapshot<any[]>(AuthState);
    // 根据工单id查询报价单列表
    this.queryJobQuotationList(this.jobId);
    // 初始化报价单下拉列表
    this.initJobQuotations();
    this.thirdpartyJobProcess = this.authService.getStatusByDictTypeAndDictValue('function_control', 'thirdparty_job_process');

  }
  queryJobQuotationList(jobId: any){
    this.jobQuotationService.getListByJno(jobId).subscribe((data: any) => {
      this.jobQuotationList = data;
    });
  }
  initJobQuotations(){
    const condition = {
      qsNo: null,
      status: null,
      pno: null,
      qsName: null,
      pageIndex: null,
      pageSize: null
    };
    this.providerService.getProviderQsByCondition(condition).subscribe((data: any) => {
      this.jobQuotations = data.list;
    });
  }
  jobQuotationChanged( value: any, index: any){
    const i = this.jobQuotations.findIndex((item: any) => {
      return item.id === value;
    });
    const jobQuotation = this.jobQuotations[i];
    this.jobQuotationList[index].guaranteePeriod = jobQuotation.guaranteePeriod;
    this.jobQuotationList[index].qsMoney = jobQuotation.qsMoney;
    this.jobQuotationList[index].qsNo = jobQuotation.qsNo;
    this.jobQuotationList[index].realQsMoney = jobQuotation.qsMoney;

    // 更新数值
    // const id = this.jobQuotationList[index].id;
    // if (id != null && id !== ''){
    //   this.jobQuotationService.update(this.jobQuotationList[index]).subscribe((result: any) => {
    //     this.jobQuotationList[index] = result;
    //     this.queryJobQuotationList(this.jobId);
    //   });
    // }else{
    //   // 添加新值
    //   this.jobQuotationService.add(this.jobQuotationList[index]).subscribe((result: any) => {
    //     this.jobQuotationList[index] = result;
    //     this.jobQuotationList  = [...this.jobQuotationList];
    //     this.queryJobQuotationList(this.jobId);
    //   });
    // }
  }
  realQsMoneyBlur(data, index){
    // if (data.id == null && data.id !== ''){
    //   if (data.realQsMoney != null && data.realQsMoney !== ''){
    //     // 添加新值
    //     this.jobQuotationService.add(data).subscribe((result: any) => {
    //       this.jobQuotationList[index] = result;
    //       this.jobQuotationList  = [...this.jobQuotationList];
    //       this.queryJobQuotationList(this.jobId);
    //     });
    //   }else{
    //     this.message.warning('请输入实际金额');
    //   }
    // }else{
    //   // 更新数值
    //   data.updateBy = this.authState.userInfo.userId;
    //   this.jobQuotationService.update(data).subscribe((result: any) => {
    //     this.jobQuotationList[index] = result;
    //     this.queryJobQuotationList(this.jobId);
    //   });
    // }
  }
  editJobQuotation(data, index){
    data.isEditable = !data.isEditable;
    if ( !data.isEditable ){
      // 保存报价单
      if (data.id == null && data.id !== ''){
        if ( data.qsNo == null && data.qsNo === ''){
          this.message.warning('请选中报价单');
          data.isEditable = true;
          return;
        }
        if (data.realQsMoney == null && data.realQsMoney === ''){
          this.message.warning('请输入实际金额');
          data.isEditable = true;
          return ;
        }
        // 添加新值
        this.jobQuotationService.add(data).subscribe((result: any) => {
          this.jobQuotationList[index] = result;
          this.jobQuotationList  = [...this.jobQuotationList];
          this.queryJobQuotationList(this.jobId);
        });
    }else{
        // 更新数值
        data.updateBy = this.authState.userInfo.userId;
        if (data.reason == null || data.reason === ''){
          this.message.warning('请填写变更金额事由');
          data.isEditable = true;
          return;
        }
        if (data.realQsMoney == null || data.realQsMoney === ''){
          this.message.warning('请输入实际金额');
          data.isEditable = true;
          return;
        }
        this.jobQuotationService.update(data).subscribe((result: any) => {
          this.jobQuotationList[index] = result;
          this.queryJobQuotationList(this.jobId);
        });
      }
    }
  }
  deleteJobQuotation(data, index){
    this.modalService.confirm({
      nzTitle: '删除',
      nzContent: '你确定要删除选中报价单?',
      nzOkText: '确定',
      nzCancelText: '取消',
      nzOnOk: () => {
        if (data.id !== null && data.id !== ''){
          // 删除记录
          this.jobQuotationService.delete(data.id).subscribe((result: any) => {
            this.queryJobQuotationList(this.jobId);
          });
        }else{
          this.jobQuotationList.shift();
          this.jobQuotationList = [...this.jobQuotationList];
        }
      }
    });
  }
  addRow(){
    if (this.jobQuotationList.length > 0){
      const id = this.jobQuotationList[0].id;
      if (id === null || id === '' ){
        this.message.warning('请先选择报价单，再添加新行');
      }else{
        const item = {
          id: null,
          jno: this.jobId,
          qid: null,
          qsNo: null,
          qsMoney: 0,
          realQsMoney: null,
          guaranteePeriod: 0,
          createBy: this.authState.userInfo.userId,
          updateBy: null,
          createTime: null,
          updateTime: null,
          isEditable: true,
          reason: null // 事由
        };
        this.jobQuotationList = [item, ...this.jobQuotationList];
      }
    }else{
      const item = {
        id: null,
        jno: this.jobId,
        qid: null,
        qsNo: null,
        qsMoney: 0,
        realQsMoney: null,
        guaranteePeriod: 0,
        createBy: this.authState.userInfo.userId,
        updateBy: null,
        createTime: null,
        updateTime: null,
        isEditable: true,
        reason: null // 事由

      };
      this.jobQuotationList = [item, ...this.jobQuotationList];
    }
  }
  showTraceInfo(jobQuotation){
    this.modalService.create({
      nzTitle: '费用变动记录',
      nzOkText: null,
      nzCancelText: '返回',
      nzBodyStyle: { padding: '10px' },
      nzWidth: 600,
      nzContent: JobQuotationTraceComponent,
      nzComponentParams: { jobQuotation },
    });
  }
}
